import { render } from "./Footer.vue?vue&type=template&id=4a2621db&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=4a2621db&lang=scss&scoped=true"

import exportComponent from "E:\\Work\\Elkashef\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2621db"]])

export default __exports__